export default __webpack_public_path__ + "static/media/ContentSuiteBlue.bb993d5d.svg";